import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/common/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./modules/auth/Login";
import Dashboard from "./modules/dashboard/Dashboard";
import hrRoutes from "./modules/hr/hrRoutes";
import AppLayout from "./components/layout/AppLayout";
import { CompanyDetails } from "./modules/company";
import CompanySettings from "./modules/companySettings/pages/CompanySettings";
import stageRoutes from "./modules/stage/stageRoutes";
import clientRoutes from "./modules/client/clientRoutes";
import inquiryRoutes from "./modules/sales/inquiry/inquiryRoutes";
import RootRedirect from "./components/common/RootRedirect";
import SalesReport from "./modules/reports/pages/SalesReport";
import TimeLagReport from "./modules/timelag/pages/TimeLagReport";
import BulkTransfer from "./modules/bulkTransfer/pages/BulkTransfer";
import paymentTermsRoutes from "./modules/paymentTerms/paymentTermsRoutes";
import NotAttended30DaysReport from "./modules/reports/pages/NotAttended30DaysReport";
import contactRoutes from "./modules/contact/contactRoutes";
import followupRoutes from "./modules/sales/followup/followupRoutes";
import ContactDirectoryReport from "./modules/reports/pages/ContactDirectoryReport";
import ContactDirectoryReportAssignedTo from "./modules/reports/pages/ContactDirectoryReportAssignedTo";
import ContactDirectoryReportCreatedBy from "./modules/reports/pages/ContactDirectoryReportCreatedBy";


const App: React.FC = () => {
  const token = localStorage.getItem("user_token");

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Root */}
          <Route path="/" element={<RootRedirect />} />


          {/* Login (NO layout) */}
          <Route path="/login" element={<Login />} />


          {/* Protected Routes WITH Layout */}
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            {stageRoutes.map((route, index: number) => (
              <Route
                key={`stage-${index}`}
                path={route.path}
                element={route.element}
              />
            ))}
            {clientRoutes.map((route, index: number) => (
              <Route
                key={`client-${index}`}
                path={route.path}
                element={route.element}
              />
            ))}

            {contactRoutes.map((route, index: number) => (
              <Route
                key={`contact-${index}`}
                path={route.path}
                element={route.element}
              />
            ))}
            {inquiryRoutes.map((route, index: number) => (
              <Route
                key={`inquiry-${index}`}
                path={route.path}
                element={route.element}
              />
            ))}
            {followupRoutes.map((route, index: number) => (
              <Route
                key={`followup-${index}`}
                path={route.path}
                element={route.element}
              />
            ))}


            {/* Dashboard */}
            <Route path="/dashboard" element={<Dashboard />} />

            {/* HR Routes */}
            {hrRoutes.map((route, index: number) => (
              <Route
                key={index}
                path={route.path}
                element={route.element}
              />
            ))}


            <Route path="/company" element={<CompanyDetails />} />
            <Route path="/company/settings" element={<CompanySettings />} />
            <Route path="/:vertical/reports" element={<SalesReport />} />
            <Route path="/reports/contact-directory" element={<ContactDirectoryReport />} />
            <Route path="/reports/contact-directory-assigned-to" element={<ContactDirectoryReportAssignedTo />} />
            <Route path="/reports/contact-directory-created-by" element={<ContactDirectoryReportCreatedBy />} />
            <Route path="/:vertical/reports/not-attended-30-days" element={<NotAttended30DaysReport />} />
            <Route path="/timelag-report" element={<TimeLagReport />} />
            <Route path="/bulk-transfer" element={<BulkTransfer />} />
            {paymentTermsRoutes.map((route, index: number) => (
              <Route
                key={`payment-${index}`}
                path={route.path}
                element={route.element}
              />
            ))}

          </Route>


          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        theme="colored"
      />
    </AuthProvider>
  );
};

export default App;
